import React, { createContext, useState } from 'react';

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
    const [messageUserData, setMessageUserData] = useState({});
    const [messageName, setMessageName] = useState(null);
    const [messageUserId, setMessageUserId] = useState(null);
    const [isMessage, setIsMessage] = useState(false);

    return (
        <MessageContext.Provider
            value={{
                messageUserData,
                setMessageUserData,
                messageName,
                setMessageName,
                messageUserId,
                setMessageUserId,
                isMessage,
                setIsMessage
            }}  >

            {children}
        </MessageContext.Provider>
    );
};
